/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AdminPasswordRecovery } from '../models/AdminPasswordRecovery';
import type { MeCreateDTO } from '../models/MeCreateDTO';
import type { PasswordRecovery } from '../models/PasswordRecovery';
import type { PasswordReset } from '../models/PasswordReset';
import type { UserDetails } from '../models/UserDetails';
import type { UsernameRecoveryAdmin } from '../models/UsernameRecoveryAdmin';
import type { UsernameRecoveryDTO } from '../models/UsernameRecoveryDTO';
import { request as __request } from '../core/request';

export class UserUtilityVService {

    /**
     * @param requestBody
     * @returns any OK
     * @throws ApiError
     */
    public static async userUtilityVUsernameRecovery(
        requestBody?: UsernameRecoveryDTO,
    ): Promise<any> {
        const result = await __request({
            method: 'POST',
            path: `/api/v1/utility/Username/Recovery`,
            body: requestBody,
            errors: {
                400: `Bad Request`,
            },
        });
        return result.body;
    }

    /**
     * @param requestBody
     * @returns any OK
     * @throws ApiError
     */
    public static async userUtilityVUsernameRecoveryAdmin(
        requestBody?: UsernameRecoveryAdmin,
    ): Promise<any> {
        const result = await __request({
            method: 'POST',
            path: `/api/v1/utility/Username/Recovery/Admin`,
            body: requestBody,
            errors: {
                400: `Bad Request`,
            },
        });
        return result.body;
    }

    /**
     * @param requestBody
     * @returns any OK
     * @throws ApiError
     */
    public static async userUtilityVPasswordRecovery(
        requestBody?: PasswordRecovery,
    ): Promise<any> {
        const result = await __request({
            method: 'POST',
            path: `/api/v1/utility/Password/Recovery`,
            body: requestBody,
            errors: {
                400: `Bad Request`,
            },
        });
        return result.body;
    }

    /**
     * @param requestBody
     * @returns any OK
     * @throws ApiError
     */
    public static async userUtilityVPasswordRecoveryAdmin(
        requestBody?: AdminPasswordRecovery,
    ): Promise<any> {
        const result = await __request({
            method: 'POST',
            path: `/api/v1/utility/Password/Recovery/Admin`,
            body: requestBody,
            errors: {
                400: `Bad Request`,
            },
        });
        return result.body;
    }

    /**
     * @param requestBody
     * @returns any OK
     * @throws ApiError
     */
    public static async userUtilityVPasswordReset(
        requestBody?: PasswordReset,
    ): Promise<any> {
        const result = await __request({
            method: 'POST',
            path: `/api/v1/utility/Password/Reset`,
            body: requestBody,
            errors: {
                400: `Bad Request`,
            },
        });
        return result.body;
    }

    /**
     * @param requestBody
     * @returns any OK
     * @throws ApiError
     */
    public static async userUtilityVPasswordResetAdmin(
        requestBody?: PasswordReset,
    ): Promise<any> {
        const result = await __request({
            method: 'POST',
            path: `/api/v1/utility/Password/Reset/Admin`,
            body: requestBody,
            errors: {
                400: `Bad Request`,
            },
        });
        return result.body;
    }

    /**
     * @param requestBody
     * @returns UserDetails Created
     * @throws ApiError
     */
    public static async userUtilityVCreateUser(
        requestBody?: MeCreateDTO,
    ): Promise<UserDetails> {
        const result = await __request({
            method: 'POST',
            path: `/api/v1/utility/Create/User`,
            body: requestBody,
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
            },
        });
        return result.body;
    }

}